"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactsList = void 0;
const vue_1 = require("vue");
const complex_data_1 = require("complex-data");
const ListView_1 = __importDefault(require("@/components/data/ListView"));
const plugin_1 = require("@/plugin");
const config_1 = require("@/config/dictionary/config");
const dictionary_1 = require("@/config/dictionary");
const DetailTitle_vue_1 = __importDefault(require("../DetailTitle.vue"));
const overdue_1 = __importDefault(require("../../api/overdue"));
const dict_1 = require("../../select/dict");
const utils_1 = require("@/config/utils");
class ContactsList extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            postData.overdueRecordId = this.$getExtra('overdueRecordId');
            overdue_1.default.overdueContactsBuild.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.ContactsList = ContactsList;
const mainData = new ContactsList({
    name: '联系人',
    prop: 'contactsList',
    module: {
        dictionary: {
            layout: {
                default: {
                    grid: 24,
                    label: 8,
                    content: 16
                }
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'overdueRecordId',
                    name: '逾期记录ID',
                    originProp: 'overdueRecordId',
                    originFrom: 'list',
                    mod: {}
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.familyrelative, {
                    prop: 'contactType',
                    name: '联系人类型',
                    originProp: 'contactType',
                    originFrom: 'list',
                    mod: {
                        list: {},
                        edit: {
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        }
                    }
                }),
                {
                    prop: 'contactName',
                    name: '姓名',
                    originProp: 'contactName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        },
                        edit: {
                            type: 'input',
                            required: true
                        },
                        build: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'contactPhone',
                    name: '联系电话',
                    originProp: 'contactPhone',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.phone
                        },
                        edit: {
                            type: 'input',
                            required: true,
                            rules: [
                                {
                                    validator(rule, val) {
                                        if (val) {
                                            if (utils_1.RegExpRule.mobilePhone.test(val) || utils_1.RegExpRule.linePhone.test(val)) {
                                                return Promise.resolve();
                                            }
                                            else {
                                                return Promise.reject();
                                            }
                                        }
                                        return Promise.reject();
                                    },
                                    message: '请输入正确的联系方式'
                                }
                            ]
                        },
                        build: {
                            $target: 'edit'
                        }
                    }
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: '创建人',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedBy',
                    name: '最后更新人',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '更新时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueContactsList.require({
                overdueRecordId: this.$getExtra('overdueRecordId')
            }).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = (0, vue_1.defineComponent)({
    name: 'ContactsList',
    components: {
        DetailTitle: DetailTitle_vue_1.default,
        ListView: ListView_1.default
    },
    props: {
        id: {
            type: String,
            required: true
        },
        defaultCollapse: {
            type: Boolean,
            required: false
        }
    },
    data() {
        return {
            collapse: this.defaultCollapse,
            mainData: mainData,
            listOption: {
                table: {
                    optionProps: {
                        bordered: true,
                        scroll: {
                            x: this.getWidth()
                        }
                    }
                },
                search: false
            }
        };
    },
    computed: {
        width() {
            return this.getWidth();
        }
    },
    watch: {
        id: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.mainData.$setExtra('overdueRecordId', this.id);
                    this.mainData.$loadData(true);
                }
            }
        }
    },
    beforeUnmount() {
        mainData.$reset();
    },
    methods: {
        getWidth() {
            return plugin_1.reactiveLayout.data.main.width - 16 * 2;
        },
        onBuild() {
            this.$refs['list-view'].onEdit();
        },
        onCollapseChange(value) {
            this.collapse = value;
        }
    }
});
